import httpService from './httpService';

import * as models from '../utils/models';
import _ from 'lodash';

interface ResetEmailPayload {
	password: string;
	confirmPassword: string;
	code: string;
}

function createCustomer(data: any, onUploadProgress: models.ProgressChange) {
	return httpService.post('/posts', data, { onUploadProgress });
}

function createUser(data: any, onUploadProgress: models.ProgressChange) {
	return httpService.post('/auth/register', data, { onUploadProgress });
}

function configureSignature(signature: string) {
	const endpoint = '/user/update-signature';
	return httpService.put(endpoint, { signature });
}

function deactivateUser(
	id: string | number,
	onUploadProgress: models.ProgressChange
) {
	return httpService.post('/auth/deactivate/' + id, { onUploadProgress });
}

function getMyProfile() {
	return httpService.get('/user/profile');
}

function getUser(userId: string | number) {
	return httpService.get('/user/' + userId);
}

function getSupervisors() {
	return httpService.get('/user/supervisors');
}

function getAllUsers() {
	return httpService.get('/user/');
}

function forgotPassword(
	email: string,
	onUploadProgress: models.ProgressChange
) {
	const endpoint: string = '/auth/forgot-password';
	return httpService.post(endpoint, { email }, { onUploadProgress });
}

function resetPassword(data: any, onUploadProgress: models.ProgressChange) {
	return httpService.put('/user/update-password', data, { onUploadProgress });
}

function resendWelcomeEmail(email: string) {
	return httpService.post('/auth/resend-reset-email', { email });
}

function setPassword(data: ResetEmailPayload, onUploadProgress: models.ProgressChange) {
	const endpoint: string = `/auth/reset-password?code=${data.code}`;

	const apiData = _.pick(data, ['password', 'confirmPassword']);
	return httpService.put(endpoint, apiData, { onUploadProgress });
}

function updateUser(data: any, onUploadProgress: models.ProgressChange) {
	const newUser = _.omit(data, ['id', 'organisationId']);
	return httpService.put('/auth/' + data.id, newUser, { onUploadProgress });
}

export {
	configureSignature,
	createCustomer,
	createUser,
	deactivateUser,
	getUser,
	getAllUsers,
	getMyProfile,
	getSupervisors,
	forgotPassword,
	resetPassword,
	resendWelcomeEmail,
	setPassword,
	updateUser,
};
